import { DiagnosticsSnapshot } from './diagnosticsTypes';

function formatSection(title: string, lines: string[]): string[] {
  return [`## ${title}`, ...lines, ''];
}

function stringifyValue(value: unknown): string {
  if (value === null || value === undefined) {
    return 'unknown';
  }
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return JSON.stringify(value);
}

export function serializeDiagnosticsSnapshot(snapshot: DiagnosticsSnapshot): string {
  const lines: string[] = [];

  lines.push(
    ...formatSection('Diagnostics Snapshot', [
      `- Captured At (UTC): ${snapshot.capturedAt}`,
      `- Environment: ${snapshot.app.env}`,
      `- URL: ${snapshot.app.url || 'unknown'}`,
      `- Path: ${snapshot.app.path || 'unknown'}`,
    ])
  );

  lines.push(
    ...formatSection('Device Details', [
      `- User Agent: ${snapshot.device.userAgent || 'unknown'}`,
      `- Language: ${snapshot.device.language || 'unknown'}`,
      `- Timezone: ${snapshot.device.timezone || 'unknown'}`,
      `- Platform: ${snapshot.device.platform || 'unknown'}`,
      `- Online: ${stringifyValue(snapshot.device.online)}`,
      `- Viewport: ${snapshot.device.viewport?.width ?? 'unknown'}x${snapshot.device.viewport?.height ?? 'unknown'}`,
      `- Screen: ${snapshot.device.screen?.width ?? 'unknown'}x${snapshot.device.screen?.height ?? 'unknown'} @${snapshot.device.screen?.pixelRatio ?? 'unknown'}x`,
      `- Effective Connection: ${snapshot.device.connection?.effectiveType || 'unknown'}`,
      `- Downlink Mbps: ${stringifyValue(snapshot.device.connection?.downlinkMbps)}`,
      `- RTT ms: ${stringifyValue(snapshot.device.connection?.rttMs)}`,
      `- Save Data: ${stringifyValue(snapshot.device.connection?.saveData)}`,
      `- Device Memory GB: ${stringifyValue(snapshot.device.memory?.deviceMemoryGb)}`,
    ])
  );

  lines.push('## Recent Breadcrumbs');
  if (snapshot.breadcrumbs.length === 0) {
    lines.push('- None', '');
  } else {
    snapshot.breadcrumbs.slice(-20).forEach((entry) => {
      lines.push(
        `- [${entry.timestamp}] ${entry.category} :: ${entry.action}${entry.details ? ` :: ${JSON.stringify(entry.details)}` : ''}`
      );
    });
    lines.push('');
  }

  lines.push('## Recent Errors');
  if (snapshot.errors.length === 0) {
    lines.push('- None', '');
  } else {
    snapshot.errors.slice(-20).forEach((entry) => {
      const detail = entry.context ? ` :: ${JSON.stringify(entry.context)}` : '';
      lines.push(
        `- [${entry.timestamp}] (${entry.source}) ${entry.category ?? 'uncategorized'} :: ${entry.message}${detail}`
      );
    });
    lines.push('');
  }

  lines.push('## Recent Analytics Events');
  if (snapshot.analyticsEvents.length === 0) {
    lines.push('- None');
  } else {
    snapshot.analyticsEvents.slice(-20).forEach((entry) => {
      lines.push(
        `- [${entry.timestamp}] (${entry.channel}) ${entry.name} :: ${JSON.stringify(entry.payload)}`
      );
    });
  }

  return lines.join('\n');
}
